<template>
  <div>
    <address v-if="address">
      <strong> {{ address.att_contact }} &nbsp;</strong>{{ address.company_name }}<br />
      {{ address.address_1 }} {{ address.address_2 }}<br />
      {{ address.zip }} {{ address.city }} {{ address.country_code
      }}<span class="ml-1"> <flag :iso="address.country_code"></flag></span>
    </address>
    <div v-else>
      <em class="text-muted">{{ 'no_details' | t }}</em>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {};
  },
  methods: {},
  props: ['address']
};
</script>

<style scoped></style>
